import {loadDataFromUrl} from "./dataLoader";
import {reloadGridDetailContent, showDetail} from "./detail";
import {updateOneField} from "./update";
import {showModalDetail} from "../global/components/modals";

export function clientSide(gridDataUrl, modal = false, tree = false, readonly = false) {
	window.gridDataUrl = gridDataUrl;

	document.querySelector("body").addEventListener("loadGrid", (event) => {
		loadDataFromUrl(gridDataUrl);
	}, { once: true });

	reloadGridDetailContent();

	var gridOptions = {
		columnDefs: window.gridColumnDefinition,
		onCellDoubleClicked: showDetail,
		onCellValueChanged: updateOneField,
	};

	if (modal) {
		gridOptions.onCellDoubleClicked = showModalDetail;
	}

	if (readonly) {
		gridOptions.onCellDoubleClicked = null;
	}

	if (tree) {
		gridOptions.treeData = true;
		gridOptions.getDataPath = function (data) {
			return data.structure.replace('}', '').replace('{', '').split(',');
		};
		gridOptions.autoGroupColumnDef = {
			headerName: "Struktura",
				cellRendererParams: {
				suppressCount: true
			}
		};
	}

	if (typeof window.getContextMenuForGrid == 'function') {
		gridOptions.getContextMenuItems = window.getContextMenuForGrid;
	}

	window.gridSettings = $.extend(window.defaultGridOptions, gridOptions);

	if (typeof window.customGridSettings == 'object') {
		window.gridSettings = $.extend(gridSettings, window.customGridSettings);
	}

	let gridContainer = document.querySelector('#ag-grid-container');

	new agGrid.Grid(gridContainer, window.gridSettings);


}